import { useQuery } from "@tanstack/react-query";
import { getAllBoards } from "controller/api";
import { ApiErrorType, GetBoardsInput } from "shared";
import { sentryLogger } from "utilz";

export const useGetAllBoards = ({
  perPageCount,
  pageNumber,
  sortColumn,
  sortDirection,
  filter,
  searchQuery,
  serviceType = "ticket_board",
  includeDeleted = false,
  enabled = true,
}: GetBoardsInput & { enabled?: boolean }) => {
  return useQuery({
    // `includeDeleted` is part of the key — the two variants return different
    // row sets and must not share a cache entry.
    queryKey: ["boards", serviceType, includeDeleted],
    queryFn: () =>
      getAllBoards({
        perPageCount,
        pageNumber,
        sortColumn,
        sortDirection,
        filter,
        searchQuery,
        serviceType,
        includeDeleted,
      }),
    enabled,
    onError: (error: ApiErrorType) =>
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "getAllBoards",
      }),
  });
};
